export const testimonials = [
    { 
      name: "María García", 
      role: "Cliente", 
      text: "Encontré al abogado perfecto para mi caso. El proceso fue sencillo y la asesoría recibida superó mis expectativas. ¡Excelente servicio!",
      rating: 5
    },
    {
      name: "Juan Pérez",
      role: "Abogado",
      text: "Esta plataforma ha transformado mi práctica legal. He podido conectar con clientes ideales y expandir mi negocio de manera significativa.",
      rating: 5
    },
    {
      name: "Ana Martínez",
      role: "Cliente",
      text: "Proceso rápido y eficiente. La calidad de los profesionales en la plataforma es excepcional. Muy satisfecha con la asesoría recibida.",
      rating: 4
    },
  ]